import React from 'react';
import { Form, Field } from 'react-final-form';
import { useUserDetails } from '@tokenized/sdk-react-private';
import { useSelectedProfileId } from '#modules/state/ProfileState';
import {
  getTokenizedBackend,
  storeBackend,
  storeApiUrl,
  getApiUrl,
} from '#config/renderer';
import {
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '#components/Elements/Dialog/Dialog';
import Label from '#components/Elements/Form/Field/Label';
import Input from '#components/Elements/Form/Controls/Input';
import Dropdown from '#components/Elements/Dropdown/Dropdown';
import SectionHeader from '#components/Elements/Form/Field/SectionHeader';
import Button from '#components/Elements/Button/Button';

export default function AppSettings({ onCloseModal }) {
  const onSubmit = ({ backend, url }) => {
    storeBackend(backend);
    storeApiUrl(url);
    onCloseModal();
    location.reload();
  };

  const values = {
    backend: getTokenizedBackend(),
    url: getApiUrl(),
  };

  const profileId = useSelectedProfileId();
  const userDetails = useUserDetails();

  return (
    <Form onSubmit={onSubmit} initialValues={values}>
      {({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <DialogHeader onCloseModal={onCloseModal}>App settings</DialogHeader>
          <DialogBody>
            <Field name="backend">
              {({ input }) => (
                <>
                  <Label>Backend:</Label>
                  <Dropdown align="left" {...input} size="medium">
                    <Dropdown.Item value="production">Production</Dropdown.Item>
                    <Dropdown.Item value="development">
                      Development
                    </Dropdown.Item>
                    <Dropdown.Item value="test">Test</Dropdown.Item>
                    <Dropdown.Item value="local">Local</Dropdown.Item>
                  </Dropdown>
                </>
              )}
            </Field>
            {values.backend === 'local' && (
              <Field name="url">
                {({ input }) => (
                  <Label>
                    API Url:
                    <Input {...input} />
                  </Label>
                )}
              </Field>
            )}

            {userDetails && (
              <>
                <SectionHeader>Identity:</SectionHeader>
                <p>
                  ProfileID:{' '}
                  <span style={{ userSelect: 'all' }}>{profileId}</span>
                </p>
                <p>
                  User:{' '}
                  <span style={{ userSelect: 'all' }}>{userDetails?.id}</span>
                </p>
              </>
            )}
            <SectionHeader>Crash reporting:</SectionHeader>
            <Button
              style={{ maxWidth: 200 }}
              color="danger"
              onClick={() => {
                throw new Error('Simulate crash button pressed');
              }}
            >
              Simulate a crash
            </Button>
          </DialogBody>
          <DialogFooter>
            <div />
            <div>
              <Button color="primary" onClick={handleSubmit}>
                Save and reload
              </Button>
            </div>
          </DialogFooter>
        </form>
      )}
    </Form>
  );
}
